import React from "react";
import { Link } from "react-router-dom";
const Education = () => {
  return (
    <>
      {/* Page Title Section */}
      <section
        className="page-title-section bg-img cover-background top-position1 left-overlay-secondary"
        data-overlay-dark="85"
        style={{
          backgroundImage: 'url("img/banner/page-title-education.jpg")',
        }}
  
      >
        <div className="container">
          <div className="row position-relative z-index-9">
            <div className="col-md-12">
              <h1>Education </h1>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>Livelihood</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content Section */}
      <section>
        <div className="container">
          <div className="row mt-n2-9">
            {/* Sidebar */}
            <div className="col-lg-4 mt-2-9 order-2 order-lg-1">
              <div className="sidebar me-xl-1-9">
                <div
                  className="widget mb-1-9 wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <h2 className="mb-4 h4">Our Work</h2>
                  <ul className="list-unstyled menu m-0">
                    <li>
                      <Link to="/skill-development">
                        Skill Development<i className="ti-arrow-right"></i>
                      </Link>
                    </li>
                    <li className="active">
                      <Link to="/education">
                        Education<i className="ti-arrow-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/health">
                        Health<i className="ti-arrow-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/abled">
                        Inclusion of Differently Abled
                        <i className="ti-arrow-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/sports">
                        Sports<i className="ti-arrow-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/community-initiatives">
                        Community Initiatives<i className="ti-arrow-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/livelihoods">
                        Livelihoods<i className="ti-arrow-right"></i>
                      </Link>
                    </li>
                  </ul>
                </div>

                <div
                  className="widget mb-1-9 wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <h2 className="mb-4 h4">Follow us</h2>
                  <div className="widget-content">
                    <ul className="social-icon-style2 list-unstyled ps-0">
                      <li className="me-1 d-inline-block"><Link to="https://www.facebook.com/www.shamayitamath.org?mibextid=ZbWKwL"target="blank"><i className="fab fa-facebook-f"></i></Link></li>
                      <li className="me-1 d-inline-block"><Link to="https://youtube.com/@shamayitamath2956?si=s7HKE99MD6pY6Kpb"target="blank"><i className="fa-brands fa-youtube"></i></Link></li>
                      <li className="me-1 d-inline-block"><Link to="https://www.instagram.com/shamayitamath?utm_source=ig_web_button_share_sheet&igsh=ODdmZWVhMTFiMw=="target="blank"><i className="fab fa-instagram"></i></Link></li>
                      <li className="me-0 d-inline-block"><Link to="https://www.linkedin.com/company/shamayitamath/?viewAsMember=true"target="blank"><i className="fab fa-linkedin-in"></i></Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Main Content */}
            <div className="col-lg-8 mt-2-9 order-1 order-lg-2">
              <div>
                <div
                  className="mb-1-9 mb-lg-5 image-hover wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <img
                    src="img/service/service-details-school.jpg"
                    alt="..."
                    className="border-radius-10"
                  />
                </div>
                <p className="mb-3 wow fadeInUp" data-wow-delay="100ms">
                  Education and childcare constitute key areas of Shamayita
                  Math’s operations. It acknowledges that children from
                  disadvantaged sections face several barriers to accessing
                  quality education and safe childhood. Shamayita Math
                  approaches and resolves these concerns through multiple
                  interventions in this sphere. This comprises Marang Buru
                  Schools (primary schools located in far-off villages),
                  Shamayita Convent School, Saptaparni for imparting cultural
                  skills among children, and Childline service (operated
                  earlier).
                </p>

                {/* Marang Buru Schools */}
                <h2
                  className="mb-4 wow fadeInUp text-primary pt-3"
                  data-wow-delay="100ms"
                >
                  Marang Buru Schools:{" "}
                </h2>
                <div className="row align-items-center mb-1-9">
                  <div
                    className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/service-details-marganmaru.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                    <p className="mb-0">
                      The relevance of strong foundational learning cannot be
                      emphasized enough. Given that many young children find
                      themselves deprived of this in rural areas, Shamayita Math
                      operates learning centers called{" "}
                      <mark>‘Marang Buru’</mark> schools in the remote villages
                      of Bankura. These centers provide quality education to
                      young children from low-income groups, as well as those
                      from SC and ST backgrounds.
                    </p>
                  </div>
                </div>
                <h4 className="mb-4 wow fadeInUp pt-3" data-wow-delay="100ms">
                  Facilitating Academic Growth of Rural Students
                </h4>
                <div className="row align-items-center mb-1-9">
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                      <p className="mb-0">
                        Initiated in 2010, these centers have been consistently contributing
                        towards enhancing the learning levels of children. Currently, five such
                        schools are operating with 300 students enrolled in them. The students are
                        provided school uniforms, bags, books, and mid-day meals to boost regular
                        attendance. The teaching techniques comprise the use of stimulating
                        methods as well as innovative teaching material. This ensures effective
                        and faster learning among children and enables them to develop functional
                        and numerical literacy and proficiency in Bengali.
                      </p>
                  </div>

                    <div
                      className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                      data-wow-delay="100ms"
                    >
                      <div className="image-hover">
                        <img
                          src="img/service/service-details-marganmaru2.jpg"
                          alt="..."
                          className="border-radius-10"
                        />
                      </div>
                    </div>
                  </div>

                <h4 className="mb-4 wow fadeInUp" data-wow-delay="100ms">
                  Teacher Empowerment
                </h4>
                <p className="mb-5 wow fadeInUp" data-wow-delay="100ms">
                  Teachers’ training is the core aspect of this initiative.
                  Regular refresher and motivation training programs are held to
                  augment the teaching skills and instill a positive outlook
                  towards the students and the program. This brings long-lasting
                  efficiency to this effort.
                </p>

                <h4 className="mb-4 wow fadeInUp" data-wow-delay="100ms">
                  Impact:
                </h4>
                <div className="row mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div className="col-md-12 mb-4 mb-md-0">
                    {[
                      "Greater access to quality education for children from underserved rural segments.",
                      "Increased level of numeracy and literacy competence among them.",
                      "Higher self-assurance among these children.",
                      "Checking vulnerability to child labor among them.",
                      "Improving their future prospects through education.",
                    ].map((text, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center border border-color-light-black p-2 mb-3"
                      >
                        <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                        <span className="ms-3 text-dark fw-bold">{text}</span>
                      </div>
                    ))}
                  </div>
                </div>

                  <h2
                    className="mb-4 wow fadeInUp text-primary pt-3"
                    data-wow-delay="100ms"
                  >
                    Shamayita Convent School: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span className="h6">
                      <a href="https://www.shamayitaschool.in" target="_blank" rel="noopener noreferrer">www.shamayitaschool.in</a> 
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <a href="https://www.facebook.com/profile.php/?id=61561152761222" target="_blank" rel="noopener noreferrer">
                        <i className="fa-brands fa-facebook-f"> <span className="h6">facebook</span></i>
                      </a>
                    </span>
                  </h2>

                  <div className="row align-items-center mb-1-9">
                    <div
                      className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                      data-wow-delay="100ms"
                    >
                      <div className="image-hover">
                        <img
                          src="img/service/convent-school-1.jpg"
                          alt="..."
                          className="border-radius-10"
                        />
                      </div>
                    </div>
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                    <p className="mb-0">
                      Shamayita Convent set up in 1996 in the Bankura district,
                      has emerged as a premiere school that follows the CBSE
                      curriculum from classes 1 to 12. The school was
                      established to provide access to high-quality schooling to
                      students belonging to low- and middle-class families,
                      including those from SC and ST communities.
                    </p>
                  </div>
                </div>

                <h4 className="mb-4 wow fadeInUp pt-3" data-wow-delay="100ms">
                  Supporting Students' Growth:
                </h4>
                <div className="row align-items-center mb-1-9">
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                    <p className="mb-0">
                      The school has a competent teaching staff that works
                      relentlessly for the academic development of the students
                      and provides support in other non-academic aspects as
                      well. The school offers the students an opportunity to
                      participate in various competitions in different subjects
                      such as Mathematics, Science, Hindi, Social Studies, and
                      more, whereby they can demonstrate their learning levels
                      and capabilities.
                    </p>
                  </div>
                  <div
                    className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/service-details-ConventSchool.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                </div>

                <div className="row mt-n1-9">
                  {[2, 6, 5].map((num) => (
                    <div
                      key={num}
                      className="col-md-4 mt-1-9 wow fadeInUp"
                      data-wow-delay="100ms"
                    >
                      <div className="image-hover">
                        <img
                          src={`img/service/convent-school-${num}.jpg`}
                          alt="..."
                          className="border-radius-10"
                        />
                      </div>
                    </div>
                  ))}
                </div>

                <h4 className="mb-4 wow fadeInUp pt-5" data-wow-delay="100ms">
                  Emphasis on Holistic Development
                </h4>
                <p className="mb-5 wow fadeInUp" data-wow-delay="100ms">
                  The school attaches high priority to extracurricular
                  activities, sports, and competitions for the overall
                  development of the children as they acquire qualities such as
                  creativity, imagination, and social adeptness and develop
                  well-rounded personalities.
                </p>

                <div className="row align-items-center mb-1-9">
                  <h4 className="mb-4 wow fadeInUp pt-3" data-wow-delay="100ms">
                    EY STEM App:
                  </h4>
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                    <p className="mb-0">
                      To enable students in the age group of 13 to 18 to learn
                      and explore Science, Math, and Technology beyond their
                      curriculum, the EY STEM app, provided by the Ernst & Young
                      Foundation has been introduced. It provides a fun approach
                      to the above-mentioned subjects. The app is encouraging
                      girls to take up careers in Science and Technology, an
                      area where girls are still underrepresented though the gap
                      is gradually reducing.
                    </p>
                  </div>
                  <div
                    className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/convent-school-4.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                </div>

                <h4 className="mb-4 wow fadeInUp" data-wow-delay="100ms">
                  Impacts:
                </h4>
                <div className="row mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div className="col-md-12 mb-4 mb-md-0">
                    {[
                      "Increased access to better education for children from families with financial constraints.",
                      "Critical thinking and problem-solving skills developed among them.",
                      "Participation in competitions in various subjects raises their academic standards.",
                      "Through the integration of arts, sports, and extracurricular activities, children develop multifaceted and self-assured personalities.",
                      "Exposure to digital technologies further raises educational abilities.",
                    ].map((text, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center border border-color-light-black p-2 mb-3"
                      >
                        <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                        <span className="ms-3 text-dark fw-bold">{text}</span>
                      </div>
                    ))}
                  </div>
                </div>
                {/* Saptaparni: Cultivating Cultural and Personal Development */}
                <h2
                  className="mb-4 wow fadeInUp text-primary pt-3"
                  data-wow-delay="100ms"
                >
                  Saptaparni: Cultivating Cultural and Personal Development
                </h2>

                <div className="row align-items-center mb-1-9">
                  <div
                    className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/saptaparni-1.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                    <p className="mb-0">
                      Within the ambit of the education program, developing the
                      skills of the children in the cultural aspects also
                      occupies a prominent position. Shamayita Math runs an
                      initiative called Saptaparni, which provides training in
                      the areas of music, dance, recitation, drawing, yoga,
                      handicrafts, and more. This equips the young children with
                      a cultural sense while developing and enhancing their
                      talents in these crafts. A well-structured training
                      program is in place for systematic development at
                      individual and group levels. Special workshops are held by
                      eminent artists and accomplished people for efficient
                      cultural and personal development.
                    </p>
                  </div>
                </div>

                <div className="row mt-n1-9">
                  {[
                    "saptaparni-2.jpg",
                    "saptaparni-3.jpg",
                    "saptaparni-4.jpg",
                  ].map((img, i) => (
                    <div
                      className="col-md-4 mt-1-9 wow fadeInUp"
                      data-wow-delay="100ms"
                      key={i}
                    >
                      <div className="image-hover">
                        <img
                          src={`img/service/${img}`}
                          alt="..."
                          className="border-radius-10"
                        />
                      </div>
                    </div>
                  ))}
                </div>

                <h4 className="mb-4 wow fadeInUp pt-5" data-wow-delay="100ms">
                  Impacts:
                </h4>

                <div className="row mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div className="col-md-12 mb-4 mb-md-0">
                    {[
                      "Better creativity and self-expression among children with regular practice of artistic mediums.",
                      "Improved confidence by showcasing their talents.",
                      "Regular practice instills a sense of discipline and a quest for improvement.",
                      "Better understanding and appreciation of the culture.",
                      "Improvement in aspects such as flexibility, physical fitness, and social skills.",
                    ].map((impact, i) => (
                      <div
                        className="d-flex align-items-center border border-color-light-black p-2 mb-3"
                        key={i}
                      >
                        <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                        <span className="ms-3 text-dark fw-bold">{impact}</span>
                      </div>
                    ))}
                  </div>
                </div>
                {/* Childline Section */}
                <h4 className="mb-4 wow fadeInUp pt-3" data-wow-delay="100ms">
                  Childline:
                </h4>

                <p className="mb-5 wow fadeInUp" data-wow-delay="100ms">
                  Till 2023, Shamayita Math was the partner organization for the
                  Childline service in Bankura district and Kirandul, Dantewada
                  district, Chhattisgarh. It responded to cases of children in
                  need of care and protection, which were reported through the
                  toll-free helpline number, 1098. Shamayita Math helped
                  children facing concerns such as child marriage, trafficking,
                  unsafe migration, mental health issues, nutrition-related
                  needs, missing and runaway children, and children affected by
                  disasters. Awareness sessions for various stakeholders on
                  child protection and available services were held regularly.
                  It partnered with police, health personnel, SHGs, and other
                  stakeholders for a holistic approach towards child protection.
                  This partnership concluded in 2023 with the announcement by
                  the Ministry of Women and Child Development (WCD), Government
                  of India about its plan to merge the service with the
                  Emergency Response Support System (ERSS) number 112 for wider
                  reach and increased coordination.
                </p>

                <h4 className="mb-4 wow fadeInUp pt-5" data-wow-delay="100ms">
                  Impacts:
                </h4>

                <div className="row mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div className="col-md-12 mb-4 mb-md-0">
                    {[
                      "Immediate assistance including emotional and psychological relief for children in distress.",
                      "Prevention of potential harm or abuse through timely intervention and support.",
                      "Safeguarding child rights and providing a child a platform to share his/her grievances in a safe environment.",
                      "Motivating children to seek assistance when needed.",
                      "Guidance to children to navigate difficult real-life situations.",
                    ].map((impact, index) => (
                      <div
                        className="d-flex align-items-center border border-color-light-black p-2 mb-3"
                        key={index}
                      >
                        <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                        <span className="ms-3 text-dark fw-bold">{impact}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="scroll-top-percentage">
          <span id="scroll-value"></span>
        </div>
      </section>
    </>
  );
};

export default Education;
